import React, { PropsWithChildren, ReactElement, useEffect, useState } from 'react'
import { IWithDropdownProps, withDropdown } from '../../../lib/hoc/WithDropdown'
import { Square } from '../../utility/square/Square'
import { NavLinkProps } from 'react-router-dom'
import { IconTriangle } from '../../icons/IconTriangle'

type NavLink = ReactElement<PropsWithChildren<NavLinkProps>>

export interface INavDropItemProps extends React.HTMLAttributes<HTMLDivElement> {
  children: NavLink | NavLink[]
  label?: string
  active?: boolean
  theme?: 'default' | 'dark'
  size?: 'sm' | 'md' | 'lg'
  decoration?: 'dot' | 'line'
}

const classDecoration = {
  line: `after:rounded-t-sm
    after:h-[3px]
    after:bottom-0
    after:left-0
    after:right-0`,
  dot: `after:h-[6px]
    after:w-[6px]
    after:top-0
    after:bottom-0
    after:right-auto
    after:left-[-18px]
    after:m-auto
    after:rounded-t-full
    after:rounded-b-full`,
}

const Drop = ({
  children,
  label,
  active = false,
  theme = 'default',
  size = 'md',
  decoration = 'line',
  open,
  onToggle,
  hidden,
  ...divAttributes
}: IWithDropdownProps & INavDropItemProps) => {
  const [isHidden, setIsHidden] = useState(!open)
  const [isHover, setIsHover] = useState(false)

  useEffect(() => {
    open ? setIsHidden(false) : setTimeout(() => setIsHidden(true), 150)
  })

  return (
    <div
      hidden={hidden}
      onMouseEnter={() => {
        setIsHover(true)
        onToggle && onToggle()
      }}
      onMouseLeave={() => {
        setIsHover(false)
        onToggle && onToggle()
      }}
      {...divAttributes}
      className={`group relative table flex-shrink cursor-pointer py-[28px] after:absolute after:block after:opacity-0 after:content-[''] ${classDecoration[decoration]} ${(active || isHover) && 'after:opacity-100'} ${theme == 'dark' ? 'after:bg-default' : 'after:bg-[#3BE1BF]'} ${size == 'sm' && 'py-[3px] pb-[6px]'} ${size == 'lg' && 'py-[13px]'}`}
    >
      <span
        className={`flex gap-3 ${
          theme == 'default' &&
          `${!isHidden || active ? 'text-[#3BE1BF]' : 'text-white'} group-hover:text-[#3BE1BF]`
        } ${
          theme == 'dark' &&
          `${!isHidden || active ? 'text-default' : 'text-focus-500'} group-hover:text-default`
        } ${size == 'md' || (size == 'sm' && 'text-[16px] leading-[24px]')} ${size == 'lg' && 'text-[24px] font-medium leading-[32px]'}`}
      >
        {label}
        <IconTriangle
          className='w-2'
          color={!isHidden || isHover || active ? '#3BE1BF' : '#FFFFFF'}
        />
      </span>
      <div
        className={`absolute left-0 top-[77px] w-[255px] flex-shrink cursor-default ${open ? 'opacity-100' : 'opacity-0'} ${isHidden && 'invisible'} z-10`}
      >
        <Square className='flex flex-col rounded-t-sm px-2 py-3' depth='300'>
          {children}
        </Square>
      </div>
    </div>
  )
}

export const NavDropItem = withDropdown(Drop)
